import React from "react";
import ProfileImage from "../../UI/ProfileImage/ProfileImage";
import ProfileText from "../../UI/ProfileText/ProfileText";
import donJazzy from "./images/donJazzy.png";
import EAD from "./images/EAD.png";
import "./Main.css";

const ClientSection = () => {
  return (
    <div className="about__client-section">
      <div className="uigrid">
        <div className="uigrid-5 about__client-section-header">
          <h3>What our</h3>
          <h3>clients have to say</h3>
        </div>
      </div>
      <div className="uigrid about__client-section-main">
        <ProfileImage image={donJazzy} key={Math.random().toString()} />
        <ProfileText
          style={{
            gridColumnEnd: "-1",
          }}
          title="“Handled the launch load”"
          description="The app went live to serious demand from day one. Orders, payments, and branch routing held up without us thinking about the infrastructure. Scalable systems was what we needed and what we got."
          personsName="Don Jazzy"
          position="Co-founder, Jazzy's Burger"
        />
      </div>
      <div className="uigrid about__client-section-main">
        <ProfileText
          title="“Complex ops, simple to run”"
          description="We run kitchens across multiple cities with inventory, branches, and fulfilment to coordinate. The platform takes care of the heavy lifting behind the scenes, our team works the kitchens, our digital holds up the systems."
          personsName="Chioma Nnadi"
          position="Eve After Dark"
        />
        <ProfileImage
          image={EAD}
          key={Math.random().toString()}
          style={{
            gridColumnEnd: "-1",
          }}
        />
      </div>
    </div>
  );
};

export default ClientSection;
